/**
 * modules/carousel.js
 * Gestion des carousels, des features et de la synchronisation
 */
import { Carousel } from 'bootstrap';
/**
 * Initialise l'animation de chargement des images du carousel
 */
export function initCarouselImageLoading() {
    const carouselImages = document.querySelectorAll(".carousel-item img");
  
    if (!carouselImages.length) return;
  
    carouselImages.forEach((img) => {
      // Ajouter une classe 'loaded' après le chargement
      img.addEventListener("load", function () {
        img.classList.add("loaded");
        adjustFeatureBlockHeight(); // Ajuster la hauteur après le chargement de chaque image
      });
  
      // Si l'image est déjà chargée du cache
      if (img.complete) {
        img.classList.add("loaded");
        adjustFeatureBlockHeight(); // Ajuster la hauteur pour les images en cache
      }
    });
  
    const carousel = document.getElementById("screenshotCarousel");
    if (carousel) {
      carousel.setAttribute("aria-roledescription", "carousel");
      carousel.setAttribute("aria-label", "Captures d'écran de FamilyStory.live");
    }
  }
  
  /**
   * Fonction pour synchroniser les features et le carousel
   */
  export function initFeatureCarouselSync() {
    // Sélectionner tous les éléments de feature
    const featureItems = document.querySelectorAll('.feature-item');
    const carousel = document.getElementById('screenshotCarousel');
    const descriptionElement = document.getElementById('sync-description');
  
    // Définir les descriptions pour chaque fonctionnalité
    const featureDescriptions = {
      '0': 'retracer les liens',
      '1': 'situer les origines',
      '2': 'revivre les époques',
      '3': 'analyser les tendances',
      '4': 'illustrer chaque détail'
    };
  
    if (!featureItems.length || !carousel || !descriptionElement) return;
  
    // Créer une instance du carousel Bootstrap
    const carouselInstance = Carousel.getInstance(carousel) ||
      new Carousel(carousel, { interval: 5000, pause: 'hover' });
  
    // Fonction pour mettre à jour la feature active et sa description
    function updateActiveFeature(featureId) {
      // Mettre à jour la classe active pour toutes les features
      featureItems.forEach(item => {
        const itemFeatureId = item.dataset.featureId;
        if (itemFeatureId === featureId) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
  
      // Mettre à jour la description
      if (featureDescriptions[featureId]) {
        descriptionElement.textContent = featureDescriptions[featureId];
      }
    }
  
    // Écouter l'événement de changement de slide
    carousel.addEventListener('slide.bs.carousel', function (event) {
      const nextSlide = event.relatedTarget;
      const featureId = nextSlide.dataset.feature;
  
      if (featureId) {
        updateActiveFeature(featureId);
      }
    });
  
    // Ajouter des écouteurs d'événements pour chaque élément de feature
    featureItems.forEach(item => {
      item.addEventListener('click', function () {
        const featureId = this.dataset.featureId;
  
        // Trouver tous les slides correspondant à cette feature
        const matchingSlides = document.querySelectorAll(`.carousel-item[data-feature="${featureId}"]`);
        if (matchingSlides.length > 0) {
          // Trouver l'index du premier slide correspondant
          const slides = document.querySelectorAll('.carousel-item');
          let slideIndex = 0;
  
          for (let i = 0; i < slides.length; i++) {
            if (slides[i].dataset.feature === featureId) {
              slideIndex = i;
              break;
            }
          }
  
          // Aller au slide correspondant
          carouselInstance.to(slideIndex);
        }
  
        // Mettre à jour la feature active et sa description sans attendre l'événement carousel
        updateActiveFeature(featureId);
      });
    });
  
    // Initialiser la feature active au chargement
    const activeSlide = document.querySelector('.carousel-item.active');
    if (activeSlide) {
      updateActiveFeature(activeSlide.dataset.feature);
    }
  }
  
  /**
   * Fonction améliorée pour ajuster la hauteur des blocs de features et du carousel
   * pour qu'ils aient exactement la même hauteur
   */
  export function adjustFeatureBlockHeight() {
    // Ne pas ajuster les hauteurs en mode desktop car le MacBook mockup gère sa propre hauteur
    if (window.innerWidth >= 768) return;
  
    const carouselBlock = document.querySelector('.carousel-block');
    const featureBlock = document.querySelector('.feature-block');
    const featuresBlock = document.querySelector('.features-block');
    const carouselContainer = document.querySelector('#screenshotCarousel');
  
    if (!carouselBlock || !featureBlock || !featuresBlock || !carouselContainer) return;
  
    // Réinitialiser les hauteurs pour obtenir les dimensions naturelles
    featuresBlock.style.height = '';
    carouselContainer.style.height = '';
    featureBlock.style.height = '';
    carouselBlock.style.height = '';
  
    // Obtenir les hauteurs actuelles
    const carouselHeight = carouselBlock.offsetHeight;
    const featureHeight = featureBlock.offsetHeight;
  
    // Utiliser la plus grande hauteur pour les deux blocs
    const maxHeight = Math.max(carouselHeight, featureHeight);
  
    // Appliquer la même hauteur aux deux blocs
    featureBlock.style.height = `${maxHeight}px`;
    carouselBlock.style.height = `${maxHeight}px`;
    featuresBlock.style.height = '100%';
    carouselContainer.style.height = '100%';
  
    // Forcer un petit délai pour s'assurer que les changements sont appliqués
    setTimeout(() => {
      // Vérifier à nouveau les hauteurs après un court délai
      const newCarouselHeight = carouselBlock.offsetHeight;
      const newFeatureHeight = featureBlock.offsetHeight;
  
      if (newCarouselHeight !== newFeatureHeight) {
        // Si les hauteurs ne sont toujours pas égales, ajuster à nouveau
        const newMaxHeight = Math.max(newCarouselHeight, newFeatureHeight);
        featureBlock.style.height = `${newMaxHeight}px`;
        carouselBlock.style.height = `${newMaxHeight}px`;
      }
    }, 50);
  }